import { render } from "./AddToCartButton.vue?vue&type=template&id=60b9733f"
import script from "./AddToCartButton.vue?vue&type=script&lang=js"
export * from "./AddToCartButton.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__